import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';
import { categories } from '@/mocks/categories';

export default function FeaturedArticles() {
  const featuredArticles = articles.slice(0, 4);

  return (
    <section className="py-14 md:py-16 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
              热门文章
            </h2>
            <p className="text-foreground-600 text-sm md:text-base">
              读者最为关注的深度分析文章
            </p>
          </div>
          <Link
            to="/category/case-timeline"
            className="hidden sm:inline-flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium transition-colors duration-200 whitespace-nowrap cursor-pointer"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {featuredArticles.map((article) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="group flex flex-col sm:flex-row gap-5 bg-background-50 rounded-lg border border-background-200/70 hover:border-primary-300/50 transition-all duration-300 overflow-hidden cursor-pointer hover:translate-y-[-2px]"
            >
              <div className="sm:w-48 h-48 sm:h-auto flex-shrink-0 overflow-hidden">
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="flex flex-col justify-center p-4 sm:p-5 sm:pl-0">
                <span className="text-xs font-medium text-accent-600 bg-accent-100/80 px-2.5 py-1 rounded-full w-fit mb-3">
                  {categories.find(c => c.slug === article.categorySlug)?.name || ''}
                </span>
                <h3 className="text-base md:text-lg font-heading font-semibold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors duration-200 line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2 mb-3">
                  {article.excerpt}
                </p>
                <div className="flex items-center gap-3 text-xs text-foreground-400 mt-auto">
                  <span className="flex items-center gap-1">
                    <i className="ri-calendar-line"></i>
                    {article.publishedAt}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line"></i>
                    {article.readTime} 分钟
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}